import { useAuth } from "@/auth/AuthProvider";
import { getRedirectPathForRole } from "@/auth/redirectPathForRole";
import { useEffect } from "react";
import { useNavigate } from "react-router";

// Redirect landing page: decides destination based on authenticated user's role.
export default function Index() {
  const navigate = useNavigate();
  const { role, roleResolved, session, loading } = useAuth();

  useEffect(() => {
    if (loading) return; // wait for auth state

    if (!session) {
      navigate("/auth");
      return;
    }

    if (role) {
      navigate(getRedirectPathForRole(role));
      return;
    }

    // Only send to /no-role once we know the role lookup succeeded with zero rows.
    // On a failed lookup (roleResolved false) wait for the retry rather than
    // wrongly telling the user they have no role.
    if (roleResolved) {
      navigate("/no-role");
    }
  }, [loading, session, role, roleResolved, navigate]);

  return <div style={{ padding: 24 }}>Loading...</div>;
}
